import input from './input';

// returns a binder for textarea element
export default function progress() {
    return input();
}
